import React from 'react';
import FlexView from 'react-flexview/lib';

export default React.memo(function Footer() {
	return (
		<FlexView hAlignContent="center" vAlignContent="center" className="Footer">
			<p>
				Created by{' '}
				<a href="https://www.pixelsheets.com" target="_blank" rel="noreferrer">
					pixelSheets
				</a>
				.
			</p>
			<p>&#169; {new Date().getFullYear()} McDondals. Get McBent.</p>
		</FlexView>
	);
});
